module.exports = __webpack_public_path__ + "img/zsbg.0b1914f.0b1914ff.png";